import { UserSquare2, BarChart3, Users, KeyRound, Shuffle } from "lucide-react";
import { GeometricBadge } from "../playful/GeometricBadge";
import { Reveal } from "./Reveal";

const NEEDS = [
  { icon: UserSquare2, who: "Creators", need: "need bio pages", tone: "pink" },
  { icon: BarChart3, who: "Marketers", need: "need attribution", tone: "mint" },
  { icon: Users, who: "Teams", need: "need governance", tone: "yellow" },
  { icon: KeyRound, who: "Developers", need: "need APIs", tone: "candy" },
  { icon: Shuffle, who: "Businesses", need: "need routing", tone: "pink" },
];

const dotText = {
  candy: "text-candy",
  pink: "text-pink",
  yellow: "text-yellow",
  mint: "text-mint",
};

/** WhyLinkLane — the "why we exist" bridge between hero and features. */
export default function WhyLinkLane() {
  return (
    <section className="mx-auto max-w-[1400px] px-5 pb-4 pt-20 md:px-10" data-testid="why-section">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
        {/* Statement */}
        <Reveal className="min-w-0">
          <GeometricBadge tone="yellow">WHY LINKLANE</GeometricBadge>
          <h2 className="mt-5 font-display text-4xl font-extrabold leading-[0.95] tracking-tight md:text-5xl">
            Most tools stop
            <span className="text-ink/60"> at shortening.</span>
          </h2>
          <p className="mt-5 max-w-lg font-sans text-lg leading-relaxed text-ink/70">
            A short link is just the start. The link you share now has to brand itself, decide where
            each visitor lands, prove what it drove, and answer to a whole team.
          </p>
          <p className="mt-5 font-display text-2xl font-extrabold leading-tight md:text-3xl">
            That's why we built LinkLane.
            <br />
            <span className="ai-gradient-text">One platform. Every link.</span>
          </p>
        </Reveal>

        {/* Needs list */}
        <Reveal delay={120} className="min-w-0">
          <div className="divide-y-2 divide-ink/10 overflow-hidden rounded-3xl border-2 border-ink bg-white shadow-sticker-md">
            {NEEDS.map(({ icon: Icon, who, need, tone }) => (
              <div key={who} className="flex items-center gap-4 px-5 py-4">
                <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border-2 border-ink bg-paper shadow-sticker-xs">
                  <Icon size={17} strokeWidth={2.5} className={dotText[tone]} />
                </span>
                <p className="font-display text-lg font-bold">
                  {who} <span className="font-sans font-normal text-ink/60">{need}.</span>
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
